/* D-SALONE 18/10/2026 (Q4-D). /pages/venerdi-nero, the filter «Tutte · Tenute · Buttate» on the salon wall. It hides the images with
   the other verdict and the case of a garment left with no image, and keeps the choice in the address (#tenute, #buttate).
   Without JavaScript every image is shown and the filter stays invisible (it keeps its place, so nothing moves when it appears). */
(function () {
  var gruppo = document.querySelector('[data-bhs-filtro]');
  if (!gruppo) return;
  document.documentElement.classList.add('bhs-js');
  var bottoni = gruppo.querySelectorAll('.bhs-filtro__b');
  var hash = { tenuta: '#tenute', buttata: '#buttate' };
  function applica(valore) {
    var visti = {};
    bottoni.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.valore === valore ? 'true' : 'false'); });
    document.querySelectorAll('.bhs-q[data-esito]').forEach(function (q) {
      var si = valore === 'tutte' || q.dataset.esito === valore;
      q.hidden = !si;
      if (si) visti[q.dataset.gruppo] = true;
    });
    document.querySelectorAll('.bhs-capo[data-gruppo]').forEach(function (c) { c.hidden = !visti[c.dataset.gruppo]; });
  }
  bottoni.forEach(function (b) {
    b.addEventListener('click', function () {
      applica(b.dataset.valore);
      try { history.replaceState(null, '', hash[b.dataset.valore] || location.pathname + location.search); } catch (e) {}
    });
  });
  if (location.hash === '#tenute') applica('tenuta');
  else if (location.hash === '#buttate') applica('buttata');
})();
